import { render, staticRenderFns } from "./MButton.vue?vue&type=template&id=4af0ad8a&scoped=true&"
import script from "./MButton.vue?vue&type=script&lang=js&"
export * from "./MButton.vue?vue&type=script&lang=js&"
import style0 from "./MButton.vue?vue&type=style&index=0&id=4af0ad8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0ad8a",
  null
  
)

export default component.exports